import { defineMessages } from 'react-intl';

import { iconChoices } from './icons';

const messages = defineMessages({
  default: {
    id: 'Default',
    defaultMessage: 'Default',
  },
  items: {
    id: 'iconsListerItems',
    defaultMessage: 'Icone',
  },
  item: {
    id: 'iconsListerItem',
    defaultMessage: 'Icona',
  },
  addItem: {
    id: 'iconsListerAddItem',
    defaultMessage: 'Aggiungi icona',
  },
  icon: {
    id: 'icon',
    defaultMessage: 'Icona',
  },
  description: {
    id: 'description',
    defaultMessage: 'Descrizione',
  },
  event_type: {
    id: 'event_type',
    defaultMessage: 'Tipo di evento',
  },
});

export const IconsListerItemSchema = ({ intl }) => ({
  title: intl.formatMessage(messages.item),
  addMessage: intl.formatMessage(messages.addItem),
  fieldsets: [
    {
      id: 'default',
      title: intl.formatMessage(messages.default),
      fields: ['icon', 'description', 'type'],
    },
  ],
  properties: {
    icon: {
      title: intl.formatMessage(messages.icon),
      choices: iconChoices,
    },
    description: {
      title: intl.formatMessage(messages.description),
    },
    type: {
      title: intl.formatMessage(messages.event_type),
    },
  },
  required: [],
});

export const IconsListerSchema = ({ intl }) => ({
  title: 'Lista di icone',
  fieldsets: [
    {
      id: 'default',
      title: intl.formatMessage(messages.default),
      fields: ['items'],
    },
  ],
  properties: {
    items: {
      title: intl.formatMessage(messages.items),
      widget: 'object_list',
      schema: IconsListerItemSchema({ intl }),
    },
  },
  required: [],
});
